const STORAGE_KEY = 'oplwidget.state.chat';

export const loadState = () => {
    try {
        const serializedState = sessionStorage.getItem(STORAGE_KEY);
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    }
    catch (err) {
        return undefined;
    }
};

export const saveState = (state) => {
    const serializedState = JSON.stringify(state);
    sessionStorage.setItem(STORAGE_KEY, serializedState);
};

export const clearState = () => {
    sessionStorage.removeItem(STORAGE_KEY);
};
